import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { currencyConvertor, isEclipseOpsTruck } from '../../../../Utils/Utility';
import { injectIntl } from 'react-intl';

function PaymentCompleted({ intl, ...props }) {
    const location = useLocation();
    const id = props.location.state.id;
    const billedData = useSelector(state => state.billed.billedPo);
    const load = billedData.loads.find(load => load.load_id === id);
    const amount = location.state.amount;
    const totalremainingAmount = location.state.remainingAmount || 0;
    const selection = location.state.selection;
    const total_bill_amount = location.state.total_bill_amount;
    const transactionId = location.state.transactionId;
    const date = new Date();
    const currentDate = date.toUTCString();
    const [counter, setCounter] = useState(7);
    const history = useHistory();
    const { formatMessage } = intl;

    useEffect(() => {
        const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);

        return () => clearInterval(timer)
    }, [counter]);

    useEffect(() => {
        if (counter == 0 && totalremainingAmount <= 0) {
            history.push({ pathname: '/' });
        }
    }, [counter]);


    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <div className="top_header_bar">
                            <div className="row">
                                <div className="col-sm col-xl-4 d-flex align-items-center p-0">

                                    <h3 className="m-0 h3-heading" title={load.load_control_num}> {load.load_control_num}</h3>
                                </div>

                            </div>
                        </div>

                        <div className="container_block" style={{ padding: '40px' }}>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <h3 className="text-success">{formatMessage({ id: "app.transaction_success" })}<br />
                                        <span className="text-muted" style={{ fontSize: '14px', fontWeight: '400' }}>{currentDate}</span>
                                    </h3>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6 col-xxl-8">
                                    {
                                        isEclipseOpsTruck(load)
                                            ?
                                            <div className="row">
                                                <div className="form-group col-sm-6">
                                                    <span className="gray_label">{formatMessage({ id: "app.total_charges" })}</span>
                                                    <p className="text-danger"><b className="text-danger">${currencyConvertor(amount)}</b></p>

                                                </div>

                                                <div className="form-group col-sm-6">
                                                    <span className="gray_label">{formatMessage({ id: "app.po" })}</span>
                                                    <p>{load.pos[0].po_number}</p>
                                                </div>
                                            </div>
                                            : <div className="row">

                                                <div className="form-group col-sm-6">
                                                    <span className="gray_label">{formatMessage({ id: "app.total_charges" })}</span>
                                                    <p className="text-danger"><b className="text-danger">${currencyConvertor(amount)}</b></p>

                                                </div>

                                                <div className="form-group col-sm-6">
                                                    <span className="gray_label">{formatMessage({ id: "app.control_number" })}</span>
                                                    <p>{load.load_control_num}</p>
                                                </div>
                                            </div>
                                    }

                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">{formatMessage({ id: "app.amount_paid" })}</span>
                                            <p><b className="remaining_amt">${currencyConvertor(amount)}</b></p>
                                        </div>
                                        {/* {
                                            isEclipseOpsTruck(load) &&
                                            <div className="form-group col-sm-6">
                                                <span className="gray_label">{formatMessage({ id: "app.service_fee" })}</span>
                                                <p><b className="remaining_amt">${currencyConvertor(serviceFee)}</b></p>
                                            </div>
                                        } */}
                                        {transactionId !== 'Success' &&
                                            <div className="form-group col-sm-6">
                                                <span className="gray_label">{formatMessage({ id: "app.reference_number" })}</span>
                                                <p>{transactionId}</p>
                                            </div>
                                        }


                                    </div>

                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">{formatMessage({ id: "app.remaining_amount" })}</span>
                                            <p><b className="remaining_amt">${currencyConvertor(totalremainingAmount)}</b></p>
                                        </div>


                                    </div>

                                </div>

                                <div className="col-sm-6 col-xxl-4">
                                    <div className="form-group">
                                        <span className="gray_label">{formatMessage({ id: "app.po" })}</span>
                                        {load.pos.map((po, index) => {
                                            return (
                                                <p key={index}>{po.po_number}</p>
                                            )
                                        })}

                                    </div>
                                </div>

                            </div>
                            {/* {totalremainingAmount > 0 &&
                                <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                    <Link to={{
                                        pathname: `/paymentdetails/${id}`,
                                        state: { totalremainingAmount, id } // your data array of objects
                                    }}>
                                        <button className="btn sw-btn-next btn-chartreuse float-right " type="button">{formatMessage({ id: "app.pay_remaining_amount" })}</button>
                                    </Link>
                                </div>
                            } */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(PaymentCompleted);
